export enum EntityType {
  ARTWORK = "3fa85f64-5717-4562-b3fc-2c963f66afa6",
  QA_PHOTO = "58084da8-9e60-4409-be25-0506dc82274d",
}
